module.exports = __webpack_public_path__ + "static/media/3 06 Tulleord Flynt er feil.7abec088.mp3";